import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from './shared/shared.module';
import { CalenderMobileViewComponent } from './shared/components/flight-search-box/calender-mobile-view/calender-mobile-view.component';
const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./components/home/home.module').then((m) => m.HomeModule),
  },

  {
    path: 'airlines/:slug', // Handle both 'en' and 'ar'
    loadChildren: () =>
      import('./components/popular-airlines/popular-airlines.module').then(
        (m) => m.PopularAirlinesModule,
      ),
  },
  {
    path: 'searchboxMob/:index',
    component: CalenderMobileViewComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes), SharedModule],
  exports: [RouterModule],
})
export class AppRoutingModule {}
